var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27081_16686)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66797 4.66669V3.32136C2.66797 2.66802 3.0373 2.07002 3.62197 1.77736L3.8113 1.68269C4.49136 1.34263 5.24622 1.17963 6.006 1.20876C6.76579 1.2379 7.50594 1.45822 8.15797 1.84936C8.55202 2.0859 8.99258 2.23441 9.44942 2.2847C9.90626 2.33499 10.3686 2.28586 10.8046 2.14069L12.9973 1.41002C13.1265 1.36705 13.265 1.36088 13.3975 1.39219C13.53 1.4235 13.6511 1.49106 13.7473 1.58731C13.8436 1.68356 13.9112 1.8047 13.9425 1.93717C13.9738 2.06963 13.9676 2.2082 13.9246 2.33736L12.7113 5.97935L13.9273 9.02002C13.9644 9.11278 13.9822 9.21214 13.9795 9.31202C13.9768 9.41189 13.9538 9.51016 13.9118 9.6008C13.8698 9.69145 13.8097 9.77255 13.7352 9.83914C13.6607 9.90572 13.5734 9.95639 13.4786 9.98802L11.2266 10.7387C10.6081 10.9449 9.9523 11.0148 9.3042 10.9437C8.65611 10.8726 8.03107 10.6621 7.47197 10.3267C7.0123 10.0508 6.49046 9.89538 5.95476 9.87475C5.41907 9.85413 4.88682 9.96898 4.4073 10.2087L4.0013 10.412V14C4.0013 14.1768 3.93106 14.3464 3.80604 14.4714C3.68102 14.5964 3.51145 14.6667 3.33464 14.6667C3.15782 14.6667 2.98826 14.5964 2.86323 14.4714C2.73821 14.3464 2.66797 14.1768 2.66797 14V10V4.66669Z",
    fill: "#D93131"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27081_16686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRed);
export default __webpack_public_path__ + "static/media/flag-red.a67bf789fa58e8497b7bbf6df1d948a6.svg";
export { ForwardRef as ReactComponent };